/** Which slide is showing: the one whose left edge is closest to where the track has scrolled to. */
export function nearestSlideIndex(slideOffsets: number[], scrollLeft: number): number {
  let nearest = 0;
  slideOffsets.forEach((offset, index) => {
    if (Math.abs(offset - scrollLeft) < Math.abs(slideOffsets[nearest] - scrollLeft)) nearest = index;
  });
  return nearest;
}
